import {get} from 'lodash/fp';
import {createSelector} from 'reselect';

import {loading as loadingState} from './root.selector';

export const getLoadingState = createSelector(
  loadingState,
  get('loginLoading'),
);
